import React, { Component, Fragment } from "react";
import unidadesSTI from "../../../../constants/unidadesSTI";
import FormDespesa from "./FormDespesa"
import CardFormDespesa from "./CardFormDespesa"
import MenuDespesa from "./MenuDespesa";
import NomeUnidade from "../../../UI/NomeUnidade";
import api from "../../../../services/api";

export default class IndexDespesa extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Form",
            user: {},
            categoriaSelecionada: 0,
            unidade: "ISTTC",
            nomeUnidade: "Instituto SENAI de Tecnologia Têxtil e Confecções (ISTTC)"
        }
    }

    async componentDidMount() {
        this.select(this.props.match.params.unidade.toUpperCase())
        await this.consultarMetasMensaisSTI();
    }

    async componentDidUpdate(prevProps, prevState) {
        if(prevState.categoriaSelecionada !== this.state.categoriaSelecionada) {
            await this.consultarMetasMensaisSTI();
        }
    }

    escolheCategoria = (categoria) => {
        this.setState({ categoriaSelecionada: categoria });
    }

    exibeConteudoForm = (selecionado) => {
        let formularios =  [
            {
                categoria: "CONSULTORIA EM TECNOLOGIA",
                nomes: [
                    "CONSULTORIA EM TECNOLOGIA",
                    "CONSULTORIA EM PROCESSOS PRODUTIVOS",
                    "CONSULTORIA PARA ATENDIMENTO DE LEGISLAÇÕES, NORMAS E REGULAMENTOS TÉCNICOS"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
                nomes: [
                    "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
                    "SERVIÇOS OPERACIONAIS"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
                nomes: [
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO DE PRODUTO",
                    "PROJETOS EM PDI DE PRODUTO",
                    "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO DE PROCESSO",
                    "PROJETOS EM PDI DE PROCESSO"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Receita", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "receita", "despesa"],
            },
            {
                categoria: "METROLOGIA",
                nomes: [
                    "METROLOGIA",
                    "ENSAIOS",
                    "CALIBRAÇÃO"
                ],
                indicadoresnome: ["Número de Atendimento", "Calibrações", "Ensaios", "Relatórios/Laudos", "receita", "despesa"],
                indicadoresid: ["numeroAtendimento", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"],
            },
            {
                categoria: "SERVIÇOS COMPLEMENTARES",
                nomes: [
                    "SERVIÇOS COMPLEMENTARES",
                    "CONSULTORIA EM GESTÃO EMPRESARIAL (SERVIÇOS INTERNOS SEM RECEITA)"
                ],
                indicadoresnome: ["Número de Atendimento", "Horas Técnicas", "Despesa"],
                indicadoresid: ["numeroAtendimento", "horasTecnicas", "despesa"],
            }
            
        ]
        return formularios[selecionado]
    }
    
    select = (unidade) => {
        
        let nome = unidadesSTI.parseNomeCurtoSTI(unidade);

        this.setState({ unidade: unidade, nomeUnidade: nome });
    }

    filtrar = (metas, unidade) => {
        if(unidade !== "Todas") {
            metas = metas.filter(v => v.unidade === unidade);
        }
        else {
        }
        return metas;
    }

    agrupar = (metas, propriedade) => {

        metas = metas.reduce((acc, atual) => {
            if(acc.hasOwnProperty(atual[propriedade])) {
                acc[atual[propriedade]].push(atual);
            }
            else {
                acc[atual[propriedade]] = [atual];
            }
            return acc;
        }, {});
        
        return metas;

    }

    consultarMetasMensaisSTI = async () => {

        let metas = await api.get("/sti/metas");
        let metasMensais = await api.get("/sti/metasmensais");
        
        metasMensais = metasMensais.data.metasMensaisSTI
        metas = metas.data.metas;

        let novasmetas = [] 
        let agrupado = this.agrupar(metas, "Sigla");
        Object.keys(agrupado).map((v, i) => {
            let agrupadoPorNome = this.agrupar(agrupado[v], "categoria");
            Object.keys(agrupadoPorNome).map((attr, i) => {
                let soma = this.soma({ metas: agrupadoPorNome[attr] });
                let obj = {
                    categoria: attr,
                    unidade: v,
                    valores: soma
                }
                novasmetas.push(obj)
            });
        });

        this.setState({
            metasMensais: [],
            metas: []
        }, () => {
            this.setState({ metas: novasmetas, metasMensais })
        })

    }

    soma = (argumentos) => {
        let { metas, unidade } =  argumentos;

        let linha =  [
            "CONSULTORIA EM TECNOLOGIA",
            "SERVIÇOS TÉCNICOS ESPECIALIZADOS",
            "PESQUISA, DESENVOLVIMENTO E INOVAÇÃO + PROJETOS",
            "METROLOGIA",
            "SERVIÇOS COMPLEMENTARES"
        ]

        let indicadoresnome = ["numeroAtendimento", "horasTecnicas", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"];

        if(["ISTAI", "ISTTC", "ISTEO"].includes(unidade)) {
            metas = metas.filter(meta => meta.Sigla === unidade);
        }
        else {
            //metas = metas.filter(meta => linha.includes(meta.categoria));
        }

        let soma = {}
        indicadoresnome.forEach(ind => {
            let vetor = Array(12).fill(0);
            soma[ind] = vetor
        });

        metas.map(val => {
            indicadoresnome.map((indicador) => {
                if(val[indicador]) {
                    val[indicador].map((valorMensal, i) => {
                        soma[indicador][i] += valorMensal;
                    });
                }
            });
        });
        return soma;

    }

    somaTotalLinhaAtuacao = (metas, formularioSelecionado) => {
        try {
            metas = metas && metas.filter(categoria => formularioSelecionado.includes(categoria.categoria.toUpperCase()))
            let soma = this.novaSoma(metas)
            return soma;
        } catch(erro) {
        }
    }

    novaSoma = (metas) => {
        let indicadoresnome = ["numeroAtendimento", "horasTecnicas", "calibracoes", "ensaios", "relatoriosELaudos", "receita", "despesa"];
        metas = metas.map(meta => meta.valores);

        let soma = {}
        indicadoresnome.forEach(ind => {
            let vetor = Array(12).fill(0);
            soma[ind] = vetor
        });
        
        metas.map(val => {
            indicadoresnome.map((indicador) => {
                if(val[indicador]) {
                    val[indicador].map((valorMensal, i) => {
                        soma[indicador][i] += valorMensal;
                    });
                }
            });
        });
        
        return soma;
    }

    onSubmit = async (event) => {
        event.preventDefault();
        
        let { despesa, categoria, unidade } = event.target;

        let linha = Array.from(categoria);
        despesa = Array.from(despesa);
        unidade = Array.from(unidade);

        despesa = despesa.map(v => Number(v.value));

        let despesas = []
        let start = 0;
        linha.map((prop, i) => {

            let end = i + 1;
            let obj = {
                unidade: unidade[i].value,
                categoria: prop.value,
                valores: {
                    despesa: despesa.slice(start, end*12)
                }
            }

            despesas.push(obj);

            start = end*12;

        });

        let somaDespesa = Array(12).fill(0);
        despesas.map((prop, i ) => {
            if(i === 0) return
            prop.valores.despesa.map((valor, i) => {
                somaDespesa[i] += valor
            });

        })

        despesas[0].valores.despesa = somaDespesa

        let status = await api.put(`/sti/metasmensais`, despesas);
        if(status.data.status === "ok") window.showNotification('Cadastrado com sucesso', 'success');
        else window.showNotification(status.data.status || 'Erro na atualização', 'danger');

        document.location.reload(true);

    }

    render() {

        let { categoriaSelecionada, metas, unidade, nomeUnidade, metasMensais } = this.state;

        categoriaSelecionada = Number(this.props.match.params.linha) || 0

        let formularioSelecionado = this.exibeConteudoForm(categoriaSelecionada);
        let { indicadoresnome, indicadoresid, categoria } = formularioSelecionado;
        
        let metasDaUnidade = metas && this.filtrar(metas, unidade);

        let teste = this.somaTotalLinhaAtuacao(metasDaUnidade, formularioSelecionado.nomes)
        
        metasDaUnidade && metasDaUnidade.push({
            categoria,
            unidade,
            valores: teste
        });

        return (
            <Fragment>

                <div className="content">

                    <NomeUnidade unidade={unidade} />

                    <CardFormDespesa produto={formularioSelecionado.categoria} onSubmit={this.onSubmit} titulo={"Cadastrar Despesas"} subtitulo={nomeUnidade} unidade={unidade}>
                        <MenuDespesa escolheCategoria={this.escolheCategoria} categoriaSelecionada={categoriaSelecionada} unidade={unidade.toLowerCase()} />
                        {formularioSelecionado.nomes.map((categoria, i) => {
                            let disabled = i === 0 ? true : false;
                            return(
                                <Fragment key={i}>
                                    <div className="card card-user p-2">
                                        <div className="card-header">
                                            <div className="table-responsive w-100 d-block">
                                                <FormDespesa 
                                                    categoria={categoria}
                                                    id={categoria}
                                                    indicadoresid={indicadoresid}
                                                    indicadoresnome={indicadoresnome}
                                                    metasDaUnidade={metasDaUnidade}
                                                    formDisabled={disabled}
                                                    unidade={unidade}
                                                    metasMensais={metasMensais}
                                                    categoriaSelecionada={categoriaSelecionada}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                </Fragment>
                            )
                        })}
                    </CardFormDespesa>

                </div>

            </Fragment>
        )
    }
}